import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const notifications = [{
  name: 'María L.',
  country: '🇦🇷 Argentina',
  timeAgo: 'hace 2 min',
  image: 'https://i.pravatar.cc/80?img=1'
}, {
  name: 'Camila T.',
  country: '🇦🇷 Argentina',
  timeAgo: 'hace 6 min',
  image: 'https://i.pravatar.cc/80?img=5'
}, {
  name: 'Lucía G.',
  country: '🇦🇷 Argentina',
  timeAgo: 'hace 10 min',
  image: 'https://i.pravatar.cc/80?img=9'
}, {
  name: 'Valentina S.',
  country: '🇦🇷 Argentina',
  timeAgo: 'hace 8 min',
  image: 'https://i.pravatar.cc/80?img=16'
}, {
  name: 'Florencia D.',
  country: '🇦🇷 Argentina',
  timeAgo: 'hace 15 min',
  image: 'https://i.pravatar.cc/80?img=20'
}, {
  name: 'Julieta M.',
  country: '🇦🇷 Argentina',
  timeAgo: 'hace 12 min',
  image: 'https://i.pravatar.cc/80?img=23'
}, {
  name: 'Agustina Z.',
  country: '🇦🇷 Argentina',
  timeAgo: 'hace 5 min',
  image: 'https://i.pravatar.cc/80?img=25'
}, {
  name: 'Sofía R.',
  country: '🇦🇷 Argentina',
  timeAgo: 'hace 9 min',
  image: 'https://i.pravatar.cc/80?img=32'
}, {
  name: 'Paula E.',
  country: '🇦🇷 Argentina',
  timeAgo: 'hace 13 min',
  image: 'https://i.pravatar.cc/80?img=44'
}, {
  name: 'Martina B.',
  country: '🇦🇷 Argentina',
  timeAgo: 'hace 7 min',
  image: 'https://i.pravatar.cc/80?img=47'
}];
export function SocialProofNotification() {
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    // Initial delay of 5 seconds
    const initialTimer = setTimeout(() => {
      setCurrentIndex(0);
      setVisible(true);
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  useEffect(() => {
    if (currentIndex < 0) return;
    // Show for 5 seconds, then hide
    const hideTimer = setTimeout(() => {
      setVisible(false);
    }, 5000);
    // 5s visible + 15s delay = 20s total cycle per notification
    const nextTimer = setTimeout(() => {
      setCurrentIndex(prev => (prev + 1) % notifications.length);
      setVisible(true);
    }, 20000);
    return () => {
      clearTimeout(hideTimer);
      clearTimeout(nextTimer);
    };
  }, [currentIndex]);
  const current = currentIndex >= 0 ? notifications[currentIndex] : null;
  return <div className="fixed bottom-4 left-4 right-4 md:left-4 md:right-auto md:w-[340px] z-50 pointer-events-none" data-id="element-165">
      <AnimatePresence data-id="element-166">
        {visible && current && <motion.div key={currentIndex} initial={{
        opacity: 0,
        y: 40,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        duration: 0.35,
        ease: 'easeOut'
      }} className="bg-white rounded-xl shadow-lg border border-gray-100 px-4 py-3 flex items-center gap-3 pointer-events-auto" style={{
        boxShadow: '0 4px 20px rgba(0,0,0,0.12)'
      }} data-id="element-167">
            {/* Profile image */}
            <img src={current.image} alt={current.name} className="w-10 h-10 rounded-full object-cover shrink-0" data-id="element-168" />

            {/* Content */}
            <div className="flex-1 min-w-0" data-id="element-169">
              <p className="text-sm text-gray-900 font-semibold leading-tight truncate" data-id="element-170">
                {current.name}{' '}
                <span className="text-[11px] font-normal text-gray-500" data-id="element-171">
                  {current.country}
                </span>
              </p>
              <p className="text-xs text-gray-600 leading-tight mt-0.5" data-id="element-172">
                compró{' '}
                <span className="font-medium" data-id="element-173">Educando a nuestros peques</span>
              </p>
              <div className="flex items-center gap-1.5 mt-1" data-id="element-174">
                <span className="text-yellow-400 text-xs leading-none" data-id="element-175">
                  ★★★★★
                </span>
                <span className="text-[10px] text-gray-400" data-id="element-176">
                  {current.timeAgo}
                </span>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}